import React from 'react';
import { Link } from 'react-router-dom';
import { team } from '../../mock';
import { ArrowUpRight } from 'lucide-react';

export default function TeamSection() {
  return (
    <section className="relative bg-[#FAF7F2] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="reveal">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-[#8B7355]" />
              <span className="text-[10px] tracking-[0.32em] uppercase text-[#8B7355]">Get to know us</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#0B0B0B] leading-[1.05] max-w-2xl">
              A team built on <span className="italic text-[#B69463]">trust</span>.
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-14 max-w-5xl mx-auto">
          {team.map((t, i) => (
            <div key={t.id} className="group reveal" style={{ transitionDelay: `${i * 100}ms` }}>
              <div className="image-zoom overflow-hidden aspect-[4/5] bg-[#EFE9DF] flex items-end justify-center max-w-sm mx-auto">
                <img
                  src={t.image}
                  srcSet={t.imageSet}
                  sizes="(max-width: 768px) 90vw, 384px"
                  alt={t.name}
                  width={800}
                  height={690}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover"
                  style={{ objectPosition: t.imagePosition || 'center top' }}
                />
              </div>
              <div className="pt-6 flex items-start justify-between">
                <div>
                  <div className="text-[10px] tracking-[0.28em] uppercase text-[#8B7355]">{t.role}</div>
                  <h3 className="font-display text-3xl text-[#0B0B0B] mt-2">{t.name}</h3>
                  <div className="text-sm text-[#0B0B0B]/60 mt-1">{t.title}</div>
                </div>
                <span className="num-badge text-3xl">0{i + 1}</span>
              </div>
              <p className="mt-4 text-[#0B0B0B]/75 leading-relaxed max-w-lg whitespace-pre-line">{t.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
